import type { IneligibilityReason } from '@rsos/reduxDataStore/src/features/conversations/tcapiAPI';

export interface Agency {
  identifier: string;
  name: string;
  type: 'conference' | 'transfer';
  state?: string;
  distanceMi?: number;
}

export type { IneligibilityReason };

export interface DirectoryAgency extends Agency {
  ineligibilityReasons: IneligibilityReason[];
}

const REASON_TEXT: Record<IneligibilityReason, string> = {
  not_conference: 'Not registered as a conference agency',
  tt911_capability_disabled:
    'RapidSOS Unite Text-to-911 Capability not enabled',
};

/** Hint text for a disabled row, joining multiple reasons into one line. */
export function ineligibilityHint(reasons: IneligibilityReason[]): string {
  return reasons.map(reason => REASON_TEXT[reason]).join(' · ');
}
